import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { DEV_MODE } from '../config/devIdentity';
import './DevRoleSwitcher.css';

/**
 * Hulpmiddel voor lokaal ontwikkelen: wissel tussen superadmin en een verzonnen
 * locatiebeheerder om te zien wat die persoon te zien krijgt. Het balkje staat
 * los van de gewone schermen en is bewust duidelijk herkenbaar, zodat het nooit
 * voor onderdeel van de applicatie wordt aangezien.
 *
 * De knop verschijnt alleen als de server testaccounts aanbiedt; online gebeurt
 * dat nooit.
 */
const DevRoleSwitcher: React.FC = () => {
  const { devIdentities, devIdentityEmail, switchDevIdentity } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  if (!DEV_MODE || devIdentities.length < 2) return null;

  const active = devIdentities.find((identity) => identity.email === devIdentityEmail);

  return (
    <div className={`dev-role-switcher ${isOpen ? 'is-open' : ''}`}>
      <button
        type="button"
        className="dev-role-switcher-toggle"
        onClick={() => setIsOpen((open) => !open)}
        title="Alleen zichtbaar tijdens lokaal ontwikkelen"
      >
        <span className="dev-role-switcher-badge">DEV</span>
        <span className="dev-role-switcher-current">
          Je kijkt als: {active ? active.label : 'onbekend'}
        </span>
        <span className="dev-role-switcher-caret" aria-hidden="true">
          {isOpen ? '▾' : '▸'}
        </span>
      </button>

      {isOpen && (
        <div className="dev-role-switcher-panel">
          <p className="dev-role-switcher-intro">
            Wissel van testaccount om te controleren wat iemand met die rol ziet en mag. De server
            past de rechten echt aan, dus je test hetzelfde als straks online.
          </p>
          <ul className="dev-role-switcher-list">
            {devIdentities.map((identity) => {
              const isActive = identity.email === devIdentityEmail;
              return (
                <li key={identity.email}>
                  <button
                    type="button"
                    className={`dev-role-switcher-option ${isActive ? 'is-active' : ''}`}
                    onClick={() => switchDevIdentity(identity.email)}
                    disabled={isActive}
                  >
                    <span className="dev-role-switcher-option-label">
                      {identity.label}
                      {isActive && <span className="dev-role-switcher-tag">nu actief</span>}
                    </span>
                    <span className="dev-role-switcher-option-description">
                      {identity.description}
                    </span>
                    <span className="dev-role-switcher-option-email">{identity.email}</span>
                  </button>
                </li>
              );
            })}
          </ul>
          <p className="dev-role-switcher-note">
            Na het wisselen laadt de pagina opnieuw, zodat je schoon begint.
          </p>
        </div>
      )}
    </div>
  );
};

export default DevRoleSwitcher;
